export const Footer = () => {
    return (
        <footer>
            <div className="footer__copyright">Fantik is official trademark belonging to <span>Asura Engineering Sp. z o.o.</span></div>
            <div className="footer__copyright">Fantik Android and iOS apps are developed by <span>Asura Engineering Sp. z o.o.</span></div>
        </footer>
    )
}